var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTwotoneEuro2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41878 13.8867C8.67786 13.8873 7.95102 13.6872 7.31783 13.3081C6.68464 12.9291 6.16948 12.3857 5.82875 11.7376H9.41878L10.042 10.5095H5.41739C5.38623 10.3069 5.36753 10.1042 5.36753 9.89546C5.36753 9.68669 5.38623 9.48406 5.41739 9.28142H9.41878L10.042 8.05335H5.82875C6.17003 7.40561 6.68531 6.86264 7.31838 6.48366C7.95145 6.10469 8.678 5.90425 9.41878 5.90423C10.4222 5.90423 11.3447 6.26651 12.0552 6.86827L13.1584 5.78142C12.132 4.87135 10.7997 4.36821 9.41878 4.36914C6.97557 4.36914 4.90631 5.91037 4.13346 8.05335H1.93955L1.31628 9.28142H3.84676C3.79651 9.68928 3.79651 10.1016 3.84676 10.5095H1.93955L1.31628 11.7376H4.13346C4.90631 13.8805 6.97557 15.4218 9.41878 15.4218C10.8585 15.4218 12.1674 14.8876 13.1584 14.0095L12.049 12.9227C11.3447 13.5244 10.4285 13.8867 9.41878 13.8867Z",
    fill: "#A3EB64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5798 9.89577H16.3167M13.9483 12.2642V7.52734",
    stroke: "#A3EB64",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTwotoneEuro2);
export default __webpack_public_path__ + "static/media/ic_twotone-euro2.efd9b1c24cd26a46ceb8506f9fa5d93b.svg";
export { ForwardRef as ReactComponent };